import type { Game } from "../../schema";

export const DIFFICULTIES: Record<
  Game["state"]["revealed_groups"][number]["difficulty"],
  { color: string; emoji: string; titleMessage: string }
> = {
  easy: {
    color: "#FFE8C0",
    emoji: "🟨",
    titleMessage: "games_categories_difficulties_straightforward",
  },
  medium: {
    color: "#B9CE5B",
    emoji: "🟩",
    titleMessage: "games_categories_difficulties_a_little_tricky",
  },
  hard: {
    color: "#67C2F1",
    emoji: "🟦",
    titleMessage: "games_categories_difficulties_challenging",
  },
  extra_hard: {
    color: "#7B1219",
    emoji: "🟥",
    titleMessage: "games_categories_difficulties_most_difficult",
  },
};
